
import Dialog from "@/components/ui/Modal/Dialog/Dialog.vue";
import AvatarUpload from "@/components/ui/AvatarUpload.vue";
import AppInput from "@/components/Form/AppInput.vue";
import AppButton from "@/components/ui/Buttons/AppButton.vue";
import AppInputsValidationProvider from "@/components/Form/AppInputsValidationProvider.vue";
import SelectInput from "@/components/Form/SelectInput.vue";
import { defineComponent } from "@vue/runtime-core";
import { AddUserModalDto } from "@/api/interfaces/users/users.dto";

interface UserDialogData {
  buttonTextUpdated: string;
  firstName: string;
  lastName: string;
  userPhone: string;
  userEmail: string;
  userPassword: string;
  repeatPassword: string;
  avatar: File | null;
  validation: boolean;
  parentTouched: boolean;
  applicationId: number;
}

const initialData = () => ({
  firstName: "",
  lastName: "",
  avatar: null,
  userEmail: "",
  userPhone: "",
  userPassword: "",
  repeatPassword: "",
  isPasswordTouch: false,
  validation: false,
  parentTouched: false,
  applicationId: 0
});

export default defineComponent({
  name: "CreateUserDialog",
  components: {
    AppButton,
    AppInput,
    SelectInput,
    AvatarUpload,
    Dialog,
    AppInputsValidationProvider
  },

  inheritAttrs: false,

  props: {
    disabled: { type: Boolean, default: true },
    opened: { type: Boolean, default: false },
    title: { type: String, default: "Create User" },
    buttonText: { type: String, required: false },
    canCancel: { type: Boolean, default: false },
    endCreate: {
      type: Function,
      required: true
    },
    loading: { type: Boolean, default: false },
    applications: { type: Array, required: true, default: () => [] }
  },
  emits: {
    hide: null
  },

  data() {
    return {
      ...initialData(),
      buttonTextUpdated: this.buttonText || this.title
    } as UserDialogData;
  },
  computed: {
    isRepeat() {
      return this.userPassword === this.repeatPassword;
    },
  },

  methods: {
    applicationSelectHandler(id: number): void {
      this.applicationId = id;
      this.applications.forEach((f: any) => (f.selected = f.id === id));
    },
    async submit(): Promise<void> {
      const data: AddUserModalDto = {
        firstName: this.firstName,
        lastName: this.lastName,
        email: this.userEmail,
        password: this.userPassword,
        phone: this.userPhone,
        applicationId: this.applicationId
      };

      if (this.avatar) {
        data.avatar = this.avatar;
      }
      const success = await this.endCreate(
        Object.fromEntries(
          Object.entries(data).filter(entry => {
            const value = entry[1];
            return typeof value === "string" ? value.length > 2 : true;
          })
        )
      );
      if (success) {
        Object.assign(this.$data, initialData());
        this.clearSelected();
      }
    },

    clearSelected() {
      this.applications.forEach((f: any) => (f.selected = false));
    },

    onChangeErrorState(error: boolean) {
      this.validation = error;
    },

    hide() {
      this.$emit("hide");
      this.clearSelected();
    },

    fileUpload(file: any) {
      this.avatar = file;
    }
  }
});
